// Admin auth helper — stores session token in localStorage, exposes helpers.
// Configurable via env vars at build time so different environments can use
// different admin URLs / storage keys without code changes.

const STORAGE_KEY = "sb_admin_token";
const EXPIRES_KEY = "sb_admin_expires";

// Secret admin URL (path only, must start with "/"). Keep alphanumeric-ish to
// avoid URL encoding surprises. Change here or via REACT_APP_ADMIN_PATH.
export const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || "/!hqbJnFU7tY3n487PzXh";

export function getToken() {
  try {
    const t = localStorage.getItem(STORAGE_KEY);
    const exp = localStorage.getItem(EXPIRES_KEY);
    if (!t) return null;
    if (exp && new Date(exp) < new Date()) {
      clearToken();
      return null;
    }
    return t;
  } catch { return null; }
}

export function setToken(token, expires_at) {
  try {
    localStorage.setItem(STORAGE_KEY, token);
    if (expires_at) localStorage.setItem(EXPIRES_KEY, expires_at);
  } catch {}
}

export function clearToken() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(EXPIRES_KEY);
  } catch {}
}

export function isAuthed() {
  return !!getToken();
}
